import React from 'react'
import classnames from 'classnames'

import { Column } from '../layout/Column.react'
import { Container } from '../layout/Container.react'
import { Row } from '../layout/Row.react'

const MAXIMUM_PAGES_DISPLAYED = 9

const truncatePages = (currentPage, pageArray) => {
  // if the total pages is beyond the maximum then we need to
  // truncate them. Also if we've gone beyond the end of the pages or
  // before the beginning of the pages then we need to rotate
  // the truncation appropriately
  if (pageArray.length <= MAXIMUM_PAGES_DISPLAYED) {
    return pageArray
  }
  const pageTruncateOffset = Math.ceil(MAXIMUM_PAGES_DISPLAYED / 2)
  let forwardTruncate = currentPage + pageTruncateOffset
  let backwardTruncate = currentPage - pageTruncateOffset + 1

  if (forwardTruncate > pageArray.length) {
    backwardTruncate += pageArray.length - forwardTruncate
    forwardTruncate = pageArray.length
  } else if (backwardTruncate < 0) {
    forwardTruncate -= backwardTruncate
    backwardTruncate = 0
  }

  return pageArray.slice(backwardTruncate, forwardTruncate)
}

function getRange (start, end) {
  const range = []
  for (let index = start; index < end; index++) {
    range.push(index)
  }
  return range
}

export const Pagination = ({ currentPage, totalItems, limit, changePage, showTotal = true }) => {
  const totalPages = () => Math.ceil(totalItems / limit)

  const pages = truncatePages(currentPage, getRange(0, totalPages()))
  const lastPage = () => totalPages() - 1

  const hasPreviousPages = () => currentPage > 0
  const hasNextPages = () => currentPage < lastPage()

  const goToFirstPage = () => hasPreviousPages() && changePage(0)
  const goToLastPage = () => hasNextPages() && changePage(lastPage())

  const goToPreviousPage = () => hasPreviousPages() && changePage(currentPage - 1)
  const goToNextPage = () => hasNextPages() && changePage(currentPage + 1)

  return (
    <Container>
      <Row>
        <Column width={100} middle>
          <section className='pagination'>

            <div>
              <a
                className={classnames('link', { active: hasPreviousPages(), disabled: !hasPreviousPages() })}
                data-testid='goToFirstPage'
                onClick={goToFirstPage}
              >&lt;&lt;
              </a>

              <a
                className={classnames('link', { active: hasPreviousPages(), disabled: !hasPreviousPages() })}
                data-testid='goToPreviousPage'
                onClick={goToPreviousPage}
              >&lt;
              </a>

              <span className='pagination-small-screen'>
                <span className='link current'>{currentPage + 1}</span>
                <span>/</span>
                <span className='link current'>{totalPages()}</span>
              </span>

              <span className='pagination-large-screen'>
                {pages.map((page) =>
                  <a
                    key={`page-link-${page}`}
                    className={classnames('link', { current: page === currentPage })}
                    data-testid={`goToPage${page}`}
                    onClick={() => changePage(page)}
                  >
                    {page + 1}
                  </a>
                )}
              </span>

              <a
                className={classnames('link', { active: hasNextPages(), disabled: !hasNextPages() })}
                disabled={!hasNextPages() && 'disabled'}
                data-testid='goToNextPage'
                onClick={goToNextPage}
              >&gt;
              </a>

              <a
                className={classnames('link', { active: hasNextPages(), disabled: !hasNextPages() })}
                disabled={!hasNextPages() && 'disabled'}
                data-testid='goToLastPage'
                onClick={goToLastPage}
              >&gt;&gt;
              </a>
            </div>

            {showTotal &&
              <div>Total: <span data-testid='totalItems'>{totalItems}</span></div>}

          </section>
        </Column>
      </Row>
    </Container>
  )
}
